import * as React from "react";

export const Logo = (params) => <img src={`${process.env.baseUrl}/assets/images/logo.svg`} alt="Dižozols - Meža lapa" {...params}/>;
